import { useTheme } from "@material-ui/core";
import React from "react";
import BluetoothAudioIcon from "@material-ui/icons/BluetoothAudio";

export const DriverEldConnectedField = () => {
  const theme = useTheme();
  return <BluetoothAudioIcon style={{ color: theme.palette.success.main }} />;
};
